import axios from 'axios'
import Router from 'next/router'
import type { PayloadProps, HeadersProps } from '.'

class ApiService {
  private baseUrl: string = ''

  private url: string = ''

  private token: string = ''

  private isMercadinho: boolean = false
  private mercadinhoID: number = 0;

  constructor(baseUrl?: string) {
    if (baseUrl) this.baseUrl = baseUrl
  }

  setUrl(url: string): ApiService {
    this.url = url
    return this
  }

  setMercadinho(active: boolean = false, mercadinhoID: number = 0) {
    this.isMercadinho = active
    this.mercadinhoID = mercadinhoID
  }

  getUrl(): string {
    return this.url
  }

  setToken = (t: string) => {
    this.token = t
    return this
  }



  private adapter() {
    const instance = axios.create({
      baseURL: this.baseUrl,
    })

    if (!this.isMercadinho) {
      instance.defaults.headers.common['X-Requested-From-App'] = 'website'
    } else {
      instance.defaults.headers.common['X-Requested-From-App'] = 'mercadinho'
      instance.defaults.headers.common['X-Requested-From-App-ID'] = `${this.mercadinhoID}`
    }

    instance.interceptors.request.use((config?: any) => {
      const cfg = config
      if (typeof window !== 'undefined') {
        const loggedIn = JSON.parse(localStorage.getItem('user-session') || '{}')
        if (this.token.length > 0) {
          cfg.headers.Authorization = `Bearer ${this.token}`
        } else if (loggedIn) {
          cfg.headers.Authorization = loggedIn?.user?.token ? `Bearer ${loggedIn?.user?.token}` : ''
        }
      }
      return cfg
    })

    instance.interceptors.response.use(
      (response) => {
        return response
      },
      (error) => {
        if (error?.response?.status === 401) {
          Router.push('/sair')
        }
        return Promise.reject(error)
      },
    )

    return instance
  }

  post(payload: PayloadProps = {}, headers: HeadersProps = {}) {
    return this.adapter().post(this.getUrl(), payload, headers)
  }

  get(params: string = '', headers: HeadersProps = {}) {
    return this.adapter().get(this.getUrl() + params, headers)
  }

  put(payload: PayloadProps = {}, headers: PayloadProps = {}) {
    return this.adapter().put(this.getUrl(), payload, headers)
  }

  delete(headers: HeadersProps = {}) {
    return this.adapter().delete(this.getUrl(), headers)
  }
}

export default ApiService
